import "./index.sass";

type DataImage = {
  image: string;
  hex: string;
};

interface ButtonsColorsProps {
  colors: DataImage[];
  handleOnClick: (color: DataImage) => void;
}

const PanelButtonsColors = ({ colors, handleOnClick }: ButtonsColorsProps) => {
  return (
    <div id="panel-buttons-colors">
      {colors?.map((color, index) => (
        <button
          key={`${color.hex}-${index}`}
          className="circle-color"
          onClick={() => handleOnClick(color)}
          style={{ backgroundColor: `${color.hex}` }}
          onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
        />
      ))}
    </div>
  );
};

export default PanelButtonsColors;
